import { CommonModule } from "@angular/common";
import {
    Component,
    EventEmitter,
    Output,
    Input,
    TemplateRef,
    ChangeDetectionStrategy,
    ViewEncapsulation,
} from "@angular/core";

@Component({
    selector: "cerrix-hover-card",
    imports: [CommonModule],
    template: '<ng-container *ngTemplateOutlet="template"></ng-container>',
    styleUrls: ["./cerrix-hover-card.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        "[class]": "panelClass",
        "(pointerenter)": "pointerEnter.emit()",
        "(pointerleave)": "pointerLeave.emit()",
    },
})
export class CerrixHoverCardComponent {
    @Input() template!: TemplateRef<any>;
    @Input() panelClass = "";
    @Output() pointerEnter = new EventEmitter<void>();
    @Output() pointerLeave = new EventEmitter<void>();
}
